/**
 * sizedImage — ask the server for an upload no wider than it's shown (v149.64).
 *
 * Uploaded images are stored up to 1600–1920 px wide. A product or gallery
 * tile shows them at under 200 px, yet downloaded the original — 100–330 KB
 * each through the origin, 4 MB for a page of 22. `GET /api/uploads/files/{id}`
 * now takes `?w=`, and returns (and caches) a copy no wider than that.
 *
 *   <img src={sizedImage(product.image_url, 640)} />
 *
 * Pick `w` for the largest the image is drawn, times two for sharp phone
 * screens: 160 for a 64 px thumbnail, 320 for an avatar, 640 for a grid
 * tile, 960 for a card as wide as a phone, 1280 for a full-width image.
 *
 * Only our own upload URLs with no query string are touched. Anything else
 * (S3 / external links, data: URIs, already-sized URLs, empty values) is
 * returned as it came, and an older server simply ignores the parameter.
 */
const UPLOAD_RE = /^(https?:\/\/[^/?#]+)?\/api\/uploads\/files\/[A-Za-z0-9_-]+$/;

export function sizedImage(url, w) {
  if (typeof url !== "string" || !w) return url;
  return UPLOAD_RE.test(url) ? `${url}?w=${w}` : url;
}

// v149.74 — An upload's URL from the API is relative (`/api/uploads/files/…`).
// That resolves on the production origin, but not when the app is served from
// another origin than the API (local dev, native). Same prefix `ImageUpload`
// applies right after an upload; use it for any URL that came back in a document.
export function uploadSrc(url) {
  if (typeof url !== "string" || !url.startsWith("/")) return url;
  return `${process.env.REACT_APP_BACKEND_URL || ""}${url}`;
}
